import { __decorate } from "tslib";
import { Component, Mixins, Watch, Prop } from 'vue-property-decorator';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import BaseSearchInput from '@/components/v2/BaseSearchInput';
import updateRecipientReadStatus from '@/plugins/graphql/mutations/v3/update-recipient-read-status.gql';
import { debounce } from 'lodash';
import { Getter } from 'vuex-class';
import moment from 'moment';
import { normalizeKey } from '@/helpers';
import { SHOPIFY, INSURANCE } from '@/helpers/constants/Bundles';
let Inbox = class Inbox extends Mixins(ViewportSizeMixin, RouterParamsAppMixin) {
    constructor() {
        super(...arguments);
        this.search = null;
        this.isRequestOnProcess = false;
        this.messengerIcon = require('@/assets/images/messenger-logo.svg');
        this.facebookIcon = require('@/assets/icons/facebook.svg');
        this.defaultPhoto = require('@/assets/images/cg_logo.png');
        this.loadMoreTimeout = null;
    }
    getCreatedAtDate(item) {
        return item?.latestInboxMessage?.createdAt
            ? this.formattedDate(item?.latestInboxMessage.createdAt)
            : '';
    }
    getOptInDate(item) {
        return this.formattedDate(item?.optInDate);
    }
    getLatestMessage(item) {
        return item?.latestInboxMessage?.message;
    }
    get sortedReicpients() {
        if (this.selectedFilter === 'active_messenger_subscriptions') {
            return this.recipients.sort((a, b) => {
                return new Date(b?.optInDate).getTime() - new Date(a?.optInDate).getTime();
            });
        }
        return this.recipients.sort((a, b) => {
            return (new Date(b?.latestInboxMessage?.createdAt).getTime() -
                new Date(a?.latestInboxMessage?.createdAt).getTime());
        });
    }
    get bundle() {
        return normalizeKey(this.bundleKey || '');
    }
    goToCustomerSegment() {
        const shopifyKey = normalizeKey(SHOPIFY).toLowerCase();
        const insurance = normalizeKey(INSURANCE).toLowerCase();
        const key = this.bundle.toLowerCase();
        if (key === shopifyKey) {
            return this.$router.push({
                name: 'shopify-customers',
                params: { appUUID: this.appUUID, to: 'shopify-customers' },
            });
        }
        if (key === insurance) {
            return this.$router.push({
                name: 'insurance-customers',
                params: { appUUID: this.appUUID, to: 'insurance-customers' },
            });
        }
        this.$router.push({
            name: 'ecommerce-customers',
            params: {
                appUUID: this.appUUID,
                to: 'ecommerce-customers',
            },
        });
    }
    onSelectedRecipientChange() {
        this.updateRecipientReadStatus(this.selectedRecipient.uuid);
    }
    formattedDate(date) {
        return moment(date).format('MM/DD/YY');
    }
    checkSentiment(item) {
        return (item?.latestSentiment?.jsonCompletion?.response?.sentiment ||
            item?.latestSentiment?.jsonCompletion?.sentiment);
    }
    getSentimentIcon(item) {
        const sentiment = this.checkSentiment(item);
        switch (sentiment) {
            case 'POSITIVE':
                return require('@/assets/icons/positive.svg');
            case 'NEUTRAL':
                return require('@/assets/icons/neutral.svg');
            case 'NEGATIVE':
                return require('@/assets/icons/negative.svg');
            default:
                return require('@/assets/icons/neutral.svg');
        }
    }
    displayRecipientPhoto(item) {
        if (!item || !item.photo) {
            return this.defaultPhoto;
        }
        const { originalUrl } = item.photo.blob;
        if (originalUrl) {
            return originalUrl;
        }
        return this.defaultPhoto;
    }
    checkMessageReadStatus(item) {
        const { messengerRead, facebookCommentRead } = item;
        if (messengerRead === null && facebookCommentRead === null) {
            return false;
        }
        switch (this.selectedFilter) {
            case 'messenger':
                return messengerRead !== null ? !messengerRead : false;
            case 'facebook_comment':
                return facebookCommentRead !== null ? !facebookCommentRead : false;
            case 'all':
                return !!((messengerRead !== null && !messengerRead) ||
                    (facebookCommentRead !== null && !facebookCommentRead));
            default:
                return false;
        }
    }
    updateRecipientReadStatus(uuid) {
        this.$apollo
            .mutate({
            mutation: updateRecipientReadStatus,
            variables: {
                input: {
                    pageRecipientUuid: uuid,
                    platformOrigin: this.selectedFilter,
                },
                selectedFilter: this.selectedFilter,
            },
        })
            .catch((err) => {
            console.log(err.message);
        });
    }
    filteredPlatformOrigin(inboxPlatformOrigin, filter) {
        if (filter !== 'all') {
            return inboxPlatformOrigin.filter((platform) => platform === filter);
        }
        return inboxPlatformOrigin;
    }
    generateIcon(originPlatform) {
        if (originPlatform === 'facebook_comment') {
            return this.facebookIcon;
        }
        if (originPlatform === 'messenger') {
            return this.messengerIcon;
        }
    }
    setClassByPlatform(originPlatform) {
        if (originPlatform === 'facebook_comment') {
            return true;
        }
    }
    handleItemClick(item) {
        const { uuid, inboxPlatformOrigin, baseUuid, photo } = item;
        const selectedItem = { uuid, inboxPlatformOrigin, baseUuid, photo };
        this.$store.commit('setSelectedRecipient', selectedItem);
        this.updateRecipientReadStatus(item.uuid);
        this.$emit('showMessage');
    }
    handleScroll(event) {
        const list = event.target;
        const { scrollHeight, scrollTop, clientHeight } = list;
        if (scrollTop + clientHeight >= scrollHeight - 50) {
            this.$emit('loadMore');
        }
    }
    mounted() {
        this.selectedFilter;
    }
};
__decorate([
    Getter('selectedFilter')
], Inbox.prototype, "selectedFilter", void 0);
__decorate([
    Getter('selectedRecipient')
], Inbox.prototype, "selectedRecipient", void 0);
__decorate([
    Getter('recipients')
], Inbox.prototype, "recipients", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], Inbox.prototype, "isloadingRecipient", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], Inbox.prototype, "isFetchMore", void 0);
__decorate([
    Watch('selectedRecipient')
], Inbox.prototype, "onSelectedRecipientChange", null);
Inbox = __decorate([
    Component({
        components: {
            BaseSearchInput,
        },
        methods: {
            debounceSearch: debounce(function () {
                this.$emit('search', this.search);
            }, 1000),
        },
    })
], Inbox);
export default Inbox;
